import { render, staticRenderFns } from "./ListDPage.vue?vue&type=template&id=31bdc7c4&scoped=true&"
import script from "./ListDPage.vue?vue&type=script&lang=js&"
export * from "./ListDPage.vue?vue&type=script&lang=js&"
import style0 from "./ListDPage.vue?vue&type=style&index=0&id=31bdc7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdc7c4",
  null
  
)

export default component.exports